"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThumborImageLib = void 0;
const enc_base64_1 = __importDefault(require("crypto-js/enc-base64"));
const hmac_sha1_1 = __importDefault(require("crypto-js/hmac-sha1"));
const axios_1 = __importDefault(require("axios"));
const helpers_1 = __importDefault(require("./helpers"));
const types_1 = require("./types");
class ThumborImageLib {
    constructor(thumborUrl, mediaBucket) {
        this.ENV = {};
        this.options = '2JF5RNFXNSu7PzFeeVgw5XtdXdisLnyz';
        this.hexRegex = /^[0-9A-F]{6}$/i;
        this.isTesting = false;
        this.ENV.THUMBOR_URL = thumborUrl;
        this.ENV.MEDIA_BUCKET = mediaBucket;
    }
    get thumborUrl() {
        return this.ENV.THUMBOR_URL;
    }
    get mediaBucketSrc() {
        var _a;
        const src = (_a = this.ENV.MEDIA_BUCKET) !== null && _a !== void 0 ? _a : '';
        return src.endsWith('/') ? src.substring(0, src.length - 1) : src;
    }
    getThumborUrlForImage(imgPath, width, height, settings) {
        const imgUrl = this.decodeImgPathAndAddMediaBucket(imgPath);
        const imageSize = this.getSizeParamMultipliedWithDpr(parseInt(width, 10), parseInt(height, 10), settings);
        const thumborUrl = `${this.getFitFromSettings(settings)}${imageSize}${this.getFiltersFromSettings(settings)}/${imgUrl}`;
        const hmacUrlSafe = this.signUrl(thumborUrl);
        return `${this.thumborUrl}/${hmacUrlSafe}/${thumborUrl}`;
    }
    decodeImgPathAndAddMediaBucket(imgPath) {
        const decodedImgPath = decodeURIComponent(imgPath);
        const encodedImgPath = encodeURIComponent(encodeURIComponent(decodedImgPath.startsWith('/') ? decodedImgPath.slice(1) : decodedImgPath));
        const imgUrl = `${this.mediaBucketSrc ? `${this.mediaBucketSrc}/` : this.mediaBucketSrc}${encodedImgPath}`;
        return imgUrl;
    }
    signUrl(thumborUrl) {
        const hmac = enc_base64_1.default.stringify((0, hmac_sha1_1.default)(thumborUrl, this.options));
        return helpers_1.default.replaceAll(helpers_1.default.replaceAll(hmac, '+', '-'), '/', '_');
    }
    removeThumborUrlFromImage(imageSource) {
        const mediaBucketIndex = imageSource.indexOf(this.mediaBucketSrc);
        if (mediaBucketIndex >= 0) {
            return imageSource.slice(mediaBucketIndex);
        }
        return imageSource;
    }
    getMetadataForImage(imgPath) {
        return __awaiter(this, void 0, void 0, function* () {
            const imgUrl = this.decodeImgPathAndAddMediaBucket(imgPath);
            const thumborUrl = `meta/${imgUrl}`;
            const hmacUrlSafe = this.signUrl(thumborUrl);
            const response = yield axios_1.default.get(`${this.thumborUrl}/${hmacUrlSafe}/${thumborUrl}`);
            return { height: response.data.thumbor.source.height, width: response.data.thumbor.source.width };
        });
    }
    getSizeParamMultipliedWithDpr(width = 1, height = 1, settings) {
        let calculatedWidth = width;
        let calculatedHeight = height;
        if (calculatedWidth <= 0) {
            calculatedWidth = 1;
        }
        if (calculatedHeight <= 0) {
            calculatedHeight = 1;
        }
        let dpr = 1;
        if (typeof window !== 'undefined') {
            dpr = Math.round(window.devicePixelRatio) || 1;
        }
        dpr = dpr < 1 ? 1 : dpr;
        calculatedWidth *= dpr;
        calculatedHeight *= dpr;
        if (!settings || settings.useCachingGroups === true) {
            [calculatedWidth, calculatedHeight] = this.increaseToNextCachingGroup(calculatedWidth, calculatedHeight);
        }
        return `${calculatedWidth}x${calculatedHeight}`;
    }
    increaseToNextCachingGroup(width, height) {
        let log2width = Math.log2(width);
        if (log2width < 5) {
            log2width = 5;
        }
        const targetWidth = Math.pow(2, Math.ceil(log2width));
        const targetHeight = Math.round(height * (targetWidth / width));
        return [targetWidth, targetHeight];
    }
    getFitFromSettings(settings) {
        let fit = types_1.ThumborFit.IN;
        if ((settings === null || settings === void 0 ? void 0 : settings.fit) !== undefined && Object.values(types_1.ThumborFit).includes(settings.fit)) {
            fit = settings.fit;
        }
        return fit.length > 0 ? `${fit}/` : fit;
    }
    getFiltersFromSettings(settings) {
        let fillColor;
        if ((settings === null || settings === void 0 ? void 0 : settings.fillColor) &&
            (Object.values(types_1.ThumborFillColor).includes(settings.fillColor) ||
                this.hexRegex.test(settings.fillColor))) {
            fillColor = settings.fillColor;
        }
        let backgroundColor;
        if ((settings === null || settings === void 0 ? void 0 : settings.backgroundColor) &&
            (Object.values(types_1.ThumborBackgroundColor).includes(settings.backgroundColor) ||
                this.hexRegex.test(settings.backgroundColor))) {
            backgroundColor = settings.backgroundColor;
        }
        let filter = '';
        if (fillColor || backgroundColor) {
            filter = `/filters`;
        }
        if (fillColor) {
            filter += `:fill(${fillColor})`;
        }
        if (backgroundColor) {
            filter += `:background_color(${backgroundColor})`;
        }
        return filter;
    }
}
exports.ThumborImageLib = ThumborImageLib;
//# sourceMappingURL=thumbor-image-lib.js.map